import { Trans, useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Button } from 'designSystem/components/Button'
import { Text } from 'designSystem/components/Text'
import { FileDown, FileText, PanelRightOpen, X } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

import { formatRelativeTime } from './relativeTime'

const HeaderRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.75rem 1rem 0.5rem;
`

const TitleIcon = styled(FileText)`
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
`

export function ArtifactPanelHeader({
  downloadedAt,
  isDownloading,
  onClose,
  onDownload,
  onOpenInTab,
  revision,
  title,
}: {
  downloadedAt?: string
  isDownloading: boolean
  onClose?: () => void
  onDownload: () => void
  onOpenInTab?: () => void
  revision: number
  title: string
}): React.ReactElement {
  const { t } = useLingui()
  const downloadedAgo = downloadedAt
    ? formatRelativeTime(downloadedAt)
    : undefined
  return (
    <HeaderRoot>
      <Box display='flex' align='center' gap='sm' minWidth='none'>
        <TitleIcon />
        <Box display='flex' direction='column' minWidth='none'>
          <Text variant='label'>{title}</Text>
          <Box display='flex' align='center' gap='xs'>
            <Text variant='caption' color='muted'>
              <Trans>Rev {revision}</Trans>
            </Text>
            {downloadedAgo ? (
              <Text variant='caption' color='muted'>
                <Trans>· Downloaded {downloadedAgo}</Trans>
              </Text>
            ) : null}
          </Box>
        </Box>
      </Box>
      <Box display='flex' align='center' gap='xs' wrap='wrap'>
        <Button
          type='button'
          size='sm'
          disabled={isDownloading}
          onClick={onDownload}>
          <FileDown data-icon='inline-start' />
          {isDownloading ? t`Downloading…` : t`Download`}
        </Button>
        {onOpenInTab ? (
          <Button type='button' variant='ghost' size='sm' onClick={onOpenInTab}>
            <PanelRightOpen data-icon='inline-start' />
            <Trans>Open in tab</Trans>
          </Button>
        ) : null}
        {onClose ? (
          <Button
            type='button'
            variant='ghost'
            size='icon'
            aria-label={t`Close document`}
            onClick={onClose}>
            <X />
          </Button>
        ) : null}
      </Box>
    </HeaderRoot>
  )
}
